import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, ArrowUpRight } from "lucide-react";
import { aiSolutions } from "@/data/content";
import { WALID_LOGO } from "@/data/assets";

export default function SiteFooter() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="bg-[color:var(--ink)] text-zinc-300 mt-24"
        >
            <div className="container-page py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <div className="flex items-center">
                            <span
                                className="signature-mark signature-mark-light w-28 h-28 md:w-36 md:h-36 shrink-0 -my-2"
                                style={{ "--logo-url": `url(${WALID_LOGO})` }}
                                aria-label="Walid Cheikh"
                            />
                        </div>
                        <p className="text-zinc-400 mt-6 max-w-md leading-relaxed">
                            Performance marketing and AI consulting for businesses that
                            want measurable growth — not vanity metrics.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div
                            className="text-xs font-mono uppercase tracking-widest mb-5"
                            style={{ color: "var(--brand-bright)" }}
                        >
                            Navigate
                        </div>
                        <ul className="space-y-3 text-sm">
                            {[
                                ["/services", "Services"],
                                ["/ai-solutions", "AI Solutions"],
                                ["/results", "Results"],
                                ["/about", "About"],
                                ["/blog", "Blog"],
                                ["/contact", "Contact"],
                                ["/growth-audit", "Growth Audit"],
                            ].map(([to, label]) => (
                                <li key={to}>
                                    <Link
                                        to={to}
                                        className="text-zinc-300 hover:text-[color:var(--brand-bright)] transition-colors"
                                    >
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div
                            className="text-xs font-mono uppercase tracking-widest mb-5"
                            style={{ color: "var(--brand-bright)" }}
                        >
                            Contact
                        </div>
                        <ul className="space-y-3 text-sm text-zinc-300">
                            <li className="flex items-start gap-3">
                                <MapPin
                                    size={15}
                                    className="mt-0.5 text-zinc-500 shrink-0"
                                />
                                <span>Dubai, Business Bay, United Arab Emirates</span>
                            </li>
                            <li className="flex items-center gap-3">
                                <Mail size={15} className="text-zinc-500" />
                                <a
                                    href="mailto:info@walidcheikh.com"
                                    className="hover:text-[color:var(--brand-bright)]"
                                >
                                    info@walidcheikh.com
                                </a>
                            </li>
                            <li className="flex items-center gap-3">
                                <Phone size={15} className="text-zinc-500" />
                                <a
                                    href="tel:+971506465164"
                                    className="hover:text-[color:var(--brand-bright)]"
                                >
                                    +971 50 64 65 164
                                </a>
                            </li>
                            <li className="flex items-center gap-3">
                                <Linkedin size={15} className="text-zinc-500" />
                                <a
                                    href="https://www.linkedin.com/in/walidcheikh/"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="hover:text-[color:var(--brand-bright)] inline-flex items-center gap-1"
                                >
                                    linkedin.com/in/walidcheikh
                                    <ArrowUpRight size={11} />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-zinc-500">
                    <div>© {year} walidcheikh.com — All rights reserved.</div>
                    <div className="flex items-center gap-5 flex-wrap">
                        <Link to="/privacy" className="hover:text-zinc-300">
                            Privacy
                        </Link>
                        <Link to="/terms" className="hover:text-zinc-300">
                            Terms
                        </Link>
                        <Link to="/refund" className="hover:text-zinc-300">
                            Refund Policy
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
